import { differenceInMinutes } from 'date-fns';
import { classifySource as runClassifier } from './sourceClassifier';
import { AI_GENERATORS, EDITORS } from './constants';

export const analyzeForensics = (file, tags) => {
  const fileModified = new Date(file.lastModified);
  const rules = [];
  
  const rawTags = {
    DateTimeOriginal: tags['DateTimeOriginal']?.description,
    Software: tags['Software']?.description || tags['CreatorTool']?.description,
    Make: tags['Make']?.description,
    Model: tags['Model']?.description,
  };

  const sourceClassification = runClassifier(file, tags);

  // REFINED RULE 1: Neutral Web Export (Prevents "Everything is AI" error)
  if (!rawTags.Make && !rawTags.Model && sourceClassification.sourceType === "Digital Export") {
    rules.push({
      code: 'WEB-1',
      msg: "Clean Web Export: No hardware metadata, but no neural artifacts detected.",
      risk: 15,
      category: 'Human / Verifiable'
    });
  }

  // REFINED RULE 2: AI Signature
  if (sourceClassification.sourceType === "AI Generated") {
    rules.push({
      code: 'NEURAL-1',
      msg: `Neural footprint detected in ${sourceClassification.logicChain[0]?.marker || 'pixel distribution'}.`,
      risk: sourceClassification.confidence > 80 ? 85 : 55,
      category: 'Completely AI'
    });
  }

  // REFINED RULE 3: Software Check
  if (rawTags.Software) {
    const sw = rawTags.Software.toLowerCase();
    if (AI_GENERATORS.some(g => sw.includes(g.toLowerCase()))) {
      rules.push({ code: 'AI-2', msg: `Generator Signature: ${rawTags.Software} found.`, risk: 80, category: 'Completely AI' });
    } else if (EDITORS.some(e => sw.includes(e.toLowerCase()))) {
      rules.push({ code: 'EDIT-1', msg: `Human Post-Processing: Exported via ${rawTags.Software}.`, risk: 10, category: 'Human / Likely Edited' });
    }
  }

  const riskScore = Math.min(rules.reduce((acc, r) => acc + r.risk, 0), 100);
  
  let finalLabel = "Human / Verifiable";
  let statusColor = "text-green-500";
  if (riskScore >= 75) { finalLabel = "Completely AI"; statusColor = "text-red-500"; }
  else if (riskScore >= 40) { finalLabel = "Highly AI"; statusColor = "text-orange-500"; }
  else if (riskScore > 0) { finalLabel = "Human / Likely Edited"; statusColor = "text-blue-400"; }

  return {
    timestamps: { fileModified },
    rawTags,
    rules,
    sourceClassification,
    scores: {
      risk: riskScore,
      veracity: 100 - riskScore,
      label: finalLabel,
      color: statusColor
    },
    summary: `EXPERT ANALYSIS: ${finalLabel}\nPrimary Evidence: ${sourceClassification.sourceType} (${sourceClassification.confidence}%)`
  };
};